// Reserve a right gutter matching the bottom-controls section's absolute close
// button (top-right) so a control's trailing content never runs under it.
export const CONSTRAINED_MAX_WIDTH = "calc(100% - 56px)";
